import { css, ElementStyles } from '@microsoft/fast-element';
import { zeroRadioStyles as styles } from '@genesislcap/foundation-zero';
import { ElementDefinitionContext, FoundationElementDefinition } from '@microsoft/fast-foundation';

export const customZeroRadioStyles = (
  context: ElementDefinitionContext,
  definition: FoundationElementDefinition
): ElementStyles => css`
  ${styles(context, definition)}

  .checked-indicator,
  .checked-indicator :host([aria-checked="true"]) {
    background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  }

  .checked-indicator,
  :host([aria-checked='true']:not([disabled])) .control:hover .checked-indicator {
    background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  }
`;
